<template>
  <BApp>
    <router-view v-slot="{ Component }">
      <Transition name="page-fade" mode="out-in">
        <component :is="Component" />
      </Transition>
    </router-view>
    <AppToast />
  </BApp>
</template>

<script setup>
import { BApp } from 'bootstrap-vue-next';
import AppToast from './components/common/AppToast.vue';
</script>
